<template>
	<div class="ks-progress-circular" :class="classes" :style="containerStyle">
		<svg :viewBox="viewBox" xmlns="http://www.w3.org/2000/svg">
			<circle class="ks-progress-circular-underlay" :cx="center" :cy="center" :r="radius" :style="underlayStyle"></circle>
			<circle class="ks-progress-circular-overlay" :cx="center" :cy="center" :r="radius" :style="overlayStyle"></circle>
		</svg>
		<div v-if="$slots.default" class="ks-progress-circular-content">
			<slot></slot>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		"value": {
			type: Number,
			default: 0
		},
		"size": {
			type: [Number, String],
			default: 32
		},
		"width": {
			type: [Number, String],
			default: 3
		},
		"color": {
			type: String,
			default: "white"
		},
		"indeterminate": {
			type: Boolean,
			default: false
		},
		"rotate": {
			type: [Number, String],
			default: -90
		}
	},
	computed: {
		"classes" () {
			return {
				"ks-progress-circular-indeterminate": this.indeterminate
			}
		},
		"numericSize" () {
			return Number(this.size)
		},
		"numericWidth" () {
			return Number(this.width)
		},
		"center" () {
			return this.numericSize / 2
		},
		"radius" () {
			return (this.numericSize - this.numericWidth) / 2
		},
		"circumference" () {
			return 2 * Math.PI * this.radius
		},
		"viewBox" () {
			return "0 0 " + this.numericSize + " " + this.numericSize
		},
		"containerStyle" () {
			return {
				width: this.numericSize + "px",
				height: this.numericSize + "px"
			}
		},
		"underlayStyle" () {
			return {
				strokeWidth: this.numericWidth + "px"
			}
		},
		"overlayStyle" () {
			var clamped = Math.max(0, Math.min(100, this.value))
			var offset = this.circumference * (1 - clamped / 100)
			return {
				strokeWidth: this.numericWidth + "px",
				strokeDasharray: this.circumference + "px",
				strokeDashoffset: (this.indeterminate ? 0 : offset) + "px",
				stroke: this.getColor(this.color),
				transform: "rotate(" + this.rotate + "deg)",
				transformOrigin: "center"
			}
		}
	},
	methods: {
		getColor (color) {
			var map = {
				"accent": "var(--ks-col-accent)",
				"success": "var(--ks-col-success)",
				"danger": "var(--ks-col-danger)",
				"warning": "var(--ks-col-warning)",
				"info": "var(--ks-col-info)",
				"white": "var(--ks-white)"
			}
			return map[color] || color
		}
	}
}
</script>

<style>
.ks-progress-circular {
	position: relative;
	display: inline-flex;
	align-items: center;
	justify-content: center;
}

.ks-progress-circular svg {
	width: 100%;
	height: 100%;
}

.ks-progress-circular-underlay {
	fill: none;
	stroke: transparent;
}

.ks-progress-circular-overlay {
	fill: none;
	stroke: var(--ks-col-accent);
	transition: stroke-dashoffset 0.3s ease;
}

.ks-progress-circular-content {
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 11px;
	color: var(--ks-font-color);
}

/* Indeterminate */
.ks-progress-circular-indeterminate svg {
	animation: ks-circular-rotate 1.4s linear infinite;
}
.ks-progress-circular-indeterminate .ks-progress-circular-overlay {
	stroke-dasharray: 80px, 200px;
	stroke-dashoffset: 0;
	animation: ks-circular-dash 1.4s ease-in-out infinite;
}

@keyframes ks-circular-rotate {
	100% {
		transform: rotate(360deg);
	}
}

@keyframes ks-circular-dash {
	0% {
		stroke-dasharray: 1px, 200px;
		stroke-dashoffset: 0;
	}
	50% {
		stroke-dasharray: 100px, 200px;
		stroke-dashoffset: -15px;
	}
	100% {
		stroke-dasharray: 100px, 200px;
		stroke-dashoffset: -125px;
	}
}
</style>
